import { App } from "antd";
import React from "react";
import ImagePreview from "./ImagePreview";

function ImagePreviewContainer({ image, id, promptId, ...props }) {
  return <ImagePreview image={image} {...props} />;
}

export default ImagePreviewContainer;
